import { render } from "./PriceFormula.vue?vue&type=template&id=4427fada&scoped=true&ts=true"
import script from "./PriceFormula.vue?vue&type=script&lang=ts"
export * from "./PriceFormula.vue?vue&type=script&lang=ts"

import "./PriceFormula.vue?vue&type=style&index=0&id=4427fada&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4427fada"]])

export default __exports__